import { useEffect, useState } from 'react';

const api = window.electronAPI || null;

export function useElectron() {
  const [version, setVersion] = useState(null);
  const [updateAvailable, setUpdateAvailable]   = useState(false);
  const [updateDownloaded, setUpdateDownloaded] = useState(false);

  useEffect(() => {
    if (!api) return;
    api.getVersion().then(setVersion);
    api.onUpdateAvailable(() => setUpdateAvailable(true));
    api.onUpdateDownloaded(() => setUpdateDownloaded(true));
  }, []);

  return {
    isElectron:    !!api,
    version,
    updateAvailable,
    updateDownloaded,
    installUpdate: () => api?.installUpdate(),
    quit:          () => api?.quit(),
  };
}
